import { Store } from '../interfaces';

const reducer = (state: Store): Store => {
    return {
        ...state,
        loading: true,
    };
};

export default reducer;
